//Router
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';

//Hooks

import { useState, useEffect } from 'react';
import { useAuthentication } from './hooks/useAuthentication';
//Context
import { AuthProvider } from './context/AuthContext';

//Styles
import './App.css';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import EditPost from './pages/EditPost/EditPost';
import CreatePost from './pages/CreatePost/CreatePost';
import Dashboard from './pages/Dashboard/Dashboard';
import Search from './pages/Search/Search';
import Post from './pages/Post/Post';


//Pages

function App() {

  const [user, setUser] = useState(undefined)
  const {auth} = useAuthentication()

  const loadingUser = user === undefined

  useEffect(() =>{
    onAuthStateChanged(auth, (user) => {
      setUser(user)
    })
  },[auth]); 

  if(loadingUser){
    return <p>carregando ...</p>;
  }

  return (
    <div className="App">
      <AuthProvider value={{user}}>
        <BrowserRouter>
          <NavBar/>
          <div className="container">
            <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="/about" element={<About/>}/>
              <Route path="/search" element={<Search/>}/>
              <Route path="/posts/:id" element={<Post/>}/>
              <Route path="/login" element={!user ? <Login/> : <Navigate to="/"/>}/>
              <Route path="/register" element={!user ? <Register/> : <Navigate to="/"/>}/>
              <Route path="/posts/create" element={user ? <CreatePost/> : <Navigate to="/"/>}/>
              <Route path="/posts/edit/:id" element={user ? <EditPost/> : <Navigate to="/"/>}/>
              <Route path="/dashboard" element={user ? <Dashboard/> : <Navigate to="/"/>}/>
            </Routes>
          </div>
          <Footer/>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
